import React from "react";
import { Box, Typography } from "@mui/material";
import { FN } from "./facilityNetworkTheme";

type Props = {
  title: string;
  subtitle?: string;
};

export default function FacilityNetworkFigmaHeading({ title, subtitle }: Props) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, minWidth: 0 }}>
      <Typography
        sx={{
          fontFamily: FN.fontFamily,
          fontSize: FN.figmaTitleSize,
          fontWeight: 600,
          color: FN.title,
          letterSpacing: FN.figmaTitleTracking,
          lineHeight: "32px",
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          sx={{
            fontFamily: FN.fontFamily,
            fontSize: 12,
            fontWeight: 400,
            color: FN.figmaAccent,
            letterSpacing: "0.25px",
            lineHeight: "16px",
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
}
